// Descriptions come back from the API as HTML. Anywhere they are used as plain
// text instead of being rendered, the markup has to come out first.
export const htmlToPlainText = (value) =>
	String(value || '')
		.replace(/<[^>]*>/g, ' ')
		.replace(/&nbsp;/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();
